export function parseTestEntry(entry: string): { searchName: string; preferredCode?: string } {
  const raw = entry.trim();
  if (!raw) {
    return { searchName: '' };
  }

  const idx = raw.indexOf(':');
  if (idx < 0) {
    return { searchName: raw };
  }

  const searchName = raw.slice(0, idx).trim();
  const preferredCode = raw.slice(idx + 1).trim();

  return { searchName, preferredCode: preferredCode || undefined };
}
